import { NotificationInline } from '../../Notification'

import * as styles from './PageHeaderNotifications.module.css'

function PageHeaderNotifications({
  className = styles.container,
  notifications,
}) {
  return (
    <div className={className}>
      {notifications.map(notification => (
        <NotificationInline {...notification} key={notification.id} />
      ))}
    </div>
  )
}

export default PageHeaderNotifications
